// Permission constants for MCMS application
// This centralizes all permission strings used throughout the application

export const PERMISSIONS = {
  // Dashboard
  DASHBOARD_PAGE_VIEW: "Dashboard_PageView",
  
  // Patients
  PATIENTS_PAGE_VIEW: "Patients_PageView",
  PATIENT_VISIT_PAGE_VIEW: "PatientVisit_PageView",
  
  // Logistics
  LOGISTICS_PAGE_VIEW: "Logistics_PageView",
  
  // Invoices
  INVOICES_PAGE_VIEW: "Invoices_PageView",
  
  // Reports
  REPORT_PAGE_VIEW: "Report_PageView",
  DONOR_REPORT_PAGE_VIEW: "Donor_Report_PageView",
  DOCTOR_REPORT_PAGE_VIEW: "Doctor_Report_PageView",
  CAMP_MANAGER_REPORT_PAGE_VIEW: "Camp_Manager_Report_PageView",
  TENANT_REPORT_PAGE_VIEW: "Tenant_Report_PageView",
  
  // Settings
  SETTINGS_PAGE_VIEW: "Settings_PageView",
  
  // Users
  USER_PAGE_VIEW: "User_PageView",
  
  // Organizations
  ORGANIZATION_PAGE_VIEW: "Organization_PageView",
  
  // Roles and Permissions
  ROLES_AND_PERMISSION_PAGE_VIEW: "RolesAndPermission_PageView",
  
  // Notifications
  NOTIFICATION_SEND_PAGE_VIEW: "Notification_Send_PageView",
  NOTIFICATION_TEMPLATE_PAGE_VIEW: "Notification_Template_PageView",
  NOTIFICATION_HISTORY_PAGE_VIEW: "Notification_History_PageView",
  SEND_NOTIFICATION_PAGE_VIEW: "Send_Notification_PageView",
  MANAGE_NOTIFICATION_PAGE_VIEW: "Manage_Notification_PageView",
  
  // Camps
  CAMP_PAGE_VIEW: "Camp_PageView",
  
  // Donors
  DONOR_PAGE_VIEW: "Donor_PageView",
};

// Helper function to check if user has specific permission
export const hasPermission = (userPermissions, permission) => {
  return userPermissions?.includes(permission);
};

// Helper function to check multiple permissions (all required)
export const hasAllPermissions = (userPermissions, permissions) => {
  return permissions.every(permission => hasPermission(userPermissions, permission));
};

// Helper function to check multiple permissions (any required)
export const hasAnyPermission = (userPermissions, permissions) => {
  return permissions.some(permission => hasPermission(userPermissions, permission));
};
